export default function disableButton(data) {
    return { type: "disableButton", data };
}
